
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RaceDetailDto } from '@aoe/client';
import * as _ from 'lodash-es';

@Component({
  selector: 'aoe-race-details',
  templateUrl: './race-details.component.html',
  styleUrls: ['./race-details.component.scss'],
  imports: []
})
export class RaceDetailsComponent implements OnInit {

  @Input()
  race!: RaceDetailDto;

  @Input()
  video?: string | null;

  constructor(
    private readonly sanitize: DomSanitizer
  ) { }

  ngOnInit(): void {
  }


  get hasLiveVideo(): boolean {
    return !_.isNil(this.video);
  }

  get urlLiveVideo(): SafeUrl {
    return this.video ? this.sanitize.bypassSecurityTrustUrl(this.video) : '';
  }

  // get registrationUrl(): string | null {
  //   const today = new Date().getTime();    
  //   const dateConditions = today > new Date(this.race.registration.openDate).getTime() && today < new Date(this.race.registration.closeDate).getTime();
  //   return this.race.registration.link && dateConditions ? this.race.registration.link : null;
  // }

}
